import { collectionServiceClient } from "@/api/collectionServiceClient";
import { GetOverdueCaseReq } from "@/pbjs/xcommon/collection_pb.js";
import InnerRequest from "./request";
// lin 获取工单分配支持的所有的参数数据
interface Options {
  caseId: number;
}
export function setGetOverdueCaseReq(arg: Options) {
  let request: any = new GetOverdueCaseReq();
  request.setCaseid(arg.caseId);
  return request;
}
export const getOverdueCaseRequest = new InnerRequest(
  collectionServiceClient,
  collectionServiceClient.getOverdueCase
);
